import {
    UPDATE_MEMBERSHIP_POOL,
    UPDATE_MEMBERSHIP_POOL_FAILURE,
    UPDATE_MEMBERSHIP_POOL_SUCCESS,
} from 'store/actions/types';

export const updateMembershipPool = (payload) => {
    return {
        type: UPDATE_MEMBERSHIP_POOL,
        payload: payload,
    };
};

export const updateMembershipPoolFailure = (error) => {
    return {
        type: UPDATE_MEMBERSHIP_POOL_FAILURE,
        error: error,
    };
};

export const updateMembershipPoolSuccess = (payload, response) => {
    return {
        type: UPDATE_MEMBERSHIP_POOL_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/membership-pools/updateMembershipPools.js